import React from 'react';

export type FractionFocus = 'numerator' | 'denominator';

interface FractionInputProps {
  numerator: string;
  denominator: string;
  focus: FractionFocus;
  onFocusChange: (focus: FractionFocus) => void;
}

export const FractionInput: React.FC<FractionInputProps> = ({
  numerator,
  denominator,
  focus,
  onFocusChange,
}) => {
  return (
    <div className="flex justify-center px-4 pt-2">
      <div className="flex flex-col items-center bg-white/60 rounded-xl px-8 py-4">
        {/* Numerator */}
        <button
          onPointerDown={(e) => { e.preventDefault(); onFocusChange('numerator'); }}
          className={`text-4xl font-bold min-w-[80px] min-h-[56px] px-4 py-2 rounded-lg transition-all ${
            focus === 'numerator'
              ? 'bg-blue-100 border-2 border-blue-500 text-gray-800'
              : 'bg-gray-50 border-2 border-transparent text-gray-600 hover:bg-gray-100'
          }`}
        >
          {numerator || '_'}
        </button>

        {/* Fraction line */}
        <div className="w-24 h-1 bg-gray-800 my-2 rounded" />

        {/* Denominator */}
        <button
          onPointerDown={(e) => { e.preventDefault(); onFocusChange('denominator'); }}
          className={`text-4xl font-bold min-w-[80px] min-h-[56px] px-4 py-2 rounded-lg transition-all ${
            focus === 'denominator'
              ? 'bg-blue-100 border-2 border-blue-500 text-gray-800'
              : 'bg-gray-50 border-2 border-transparent text-gray-600 hover:bg-gray-100'
          }`}
        >
          {denominator || '_'}
        </button>

        {/* Focus indicator */}
        <div className="mt-3 text-xs text-gray-500">
          {focus === 'numerator' ? '分子を入力中' : '分母を入力中'}
        </div>
      </div>
    </div>
  );
};
